/**
 * Source: https://github.com/vireshshah/custom-protocol-check/blob/master/index.js
 * https://github.com/vireshshah/custom-protocol-check
 */
const getUserAgent = () => {
    return window.navigator.userAgent;
};

const userAgentContains = (browserName: string) => {
    browserName = browserName.toLowerCase();
    return (
        getUserAgent()
            .toLowerCase()
            .indexOf(browserName) > -1
    );
}

export const isOSX = () => {
    return userAgentContains('Macintosh');
};

declare global {
    interface Window {
        MSStream: any;
    }
}

/**
 * https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
 */
export const isIphone = () => {
    return /iPad|iPhone|iPod/.test(getUserAgent()) && !window.MSStream;
};

export const isFirefox = () => {
    return userAgentContains('firefox');
};

export const isEdge = () => {
    const ua = getUserAgent().toLowerCase();
    return ua.indexOf('edge') > 0;
};

export const isChrome = () => {
    // IE11 returns undefined for window.chrome
    // and new Opera 30 outputs true for window.chrome
    // but needs to check if window.opr is not undefined
    // and new IE Edge outputs to true for window.chrome
    // and if not iOS Chrome check
    // @ts-ignore
    const isChromium = window.chrome;
    const winNav = window.navigator;
    const vendorName = winNav.vendor;
    // @ts-ignore
    const isOpera = typeof window.opr !== 'undefined';
    const isEdge = winNav.userAgent.indexOf('Edge') > -1;
    const isIOSChrome = winNav.userAgent.match('CriOS');
    return ((isChromium !== null &&
        typeof isChromium !== 'undefined' &&
        vendorName === 'Google Inc.' && !isOpera && !isEdge) || isIOSChrome);
};

export const isOpera = () => {
    return userAgentContains(' OPR/');
};

export const getBrowserVersion = () => {
    const ua = window.navigator.userAgent;
    let tem,
        M =
            ua.match(
                /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
            ) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return parseFloat(tem[1]) || "";
    }
    if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) {
            return parseFloat(tem[2]);
        }
    }
    M = M[2]
        ? [M[1], M[2]]
        : [window.navigator.appName, window.navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return parseFloat(M[1]);
};

